<template>
	<div class="flex flex-col gap-1">
		<p v-if="message">{{ message }}</p>
		<!-- Icon-only on purpose: a label would need translation keys that don't exist yet. -->
		<button
			v-if="details.length > 0"
			type="button"
			class="self-end text-black hover:opacity-70 dark:text-white"
			@click="expanded = !expanded"
		>
			<AppIcon :icon="expanded ? 'eye-slash' : 'eye'"/>
		</button>
		<div v-if="expanded" class="flex flex-col gap-0.5">
			<p v-for="(detail, index) in details" :key="index">{{ detail }}</p>
		</div>
	</div>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		message?: string | null;
		details?: string[];
	}>(),
	{
		message: null,
		details: () => [],
	},
);

const expanded = ref(false);
</script>
